import { render, staticRenderFns } from "./UserSetup.vue?vue&type=template&id=80e709e8&scoped=true&"
import script from "./UserSetup.vue?vue&type=script&lang=js&"
export * from "./UserSetup.vue?vue&type=script&lang=js&"
import style0 from "./UserSetup.vue?vue&type=style&index=0&id=80e709e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e709e8",
  null
  
)

export default component.exports